import { useEffect, useRef, useState } from "react";
import { RiWhatsappLine } from "react-icons/ri";

import "./index-drag.css"
import { whatsAppRedirect } from "../../../../hooks/common";

export function DraggableWhatsAppButton() {
  const buttonRef = useRef(null);

  const [position, setPosition] = useState({
    x: 0,
    y: 0,
  });

  const [isDragging, setIsDragging] = useState(false);

  const dragStartOffset = useRef({
    x: 0,
    y: 0,
  });

  // Start button in the bottom-right corner
  useEffect(() => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    setPosition({
      x: window.innerWidth - rect.width - 24,
      y: window.innerHeight - rect.height - 80,
    });
  }, []);

  const handlePointerDown = (e) => {
    e.preventDefault();

    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    dragStartOffset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };

    // Keeps receiving pointer events even if
    // the pointer leaves the button
    buttonRef.current.setPointerCapture(e.pointerId);

    setIsDragging(true);
  };

  useEffect(() => {
    const handlePointerMove = (e) => {
      if (!isDragging) return;

      const button = buttonRef.current;

      if (!button) return;

      const rect = button.getBoundingClientRect();

      let newX =
        e.clientX - dragStartOffset.current.x;

      let newY =
        e.clientY - dragStartOffset.current.y;

      // Keep the button inside the viewport
      const maxX = window.innerWidth - rect.width;
      const maxY = window.innerHeight - rect.height;

      newX = Math.max(0, Math.min(newX, maxX));
      newY = Math.max(0, Math.min(newY, maxY));

      setPosition({
        x: newX,
        y: newY,
      });
    };

    const handlePointerUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener(
        "pointermove",
        handlePointerMove
      );

      window.addEventListener(
        "pointerup",
        handlePointerUp
      );
    }

    return () => {
      window.removeEventListener(
        "pointermove",
        handlePointerMove
      );

      window.removeEventListener(
        "pointerup",
        handlePointerUp
      );
    };
  }, [isDragging]);

  return (
    <button
      onClick={whatsAppRedirect}
      ref={buttonRef}
      className={`whatsapp-button ${
        isDragging ? "dragging" : ""
      }`}
      style={{
        position: "fixed",
        left: `${position.x}px`,
        top: `${position.y}px`,
      }} 
      onPointerDown={handlePointerDown}
      aria-label="Contact us on WhatsApp"
    >
      <RiWhatsappLine/>
    </button>
  );
}